import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/reset.css';
import '@/assets/css/global.scss';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// Progress Bar
import '@/plugins/progressbar';
import VuePageTransition from "vue-page-transition";
import mqtt from 'mqtt'

Vue.use(VuePageTransition);
Vue.prototype.$mqtt = mqtt
Vue.use(ElementUI);
Vue.use(ElementUI, { size: 'small' });
Vue.config.productionTip = false;
Vue.prototype.$globalIP = null;
const script = document.createElement('script');
script.src = 'https://api.ipify.org?format=jsonp&callback=getGlobalIP';
document.head.appendChild(script);

window.getGlobalIP = (json) => {
  Vue.prototype.$globalIP = json.ip;
}

if (process.env.NODE_ENV !== 'development') {
  console.log = function() {}
  console.warning = function() {}
  console.error = function() {}
}

export default new Vue({
  ...App,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
